const isProd = process.env.NODE_ENV === "production";

export const logger = {
  warn: isProd ? () => {} : (...args) => console.warn(...args),
};
